import { Matrix4 } from '@math.gl/core';

class Transform {
  transform: Matrix4;

  mode: 'accumlative' | 'set' = 'set';

  constructor() {
    this.transform = new Matrix4().identity();
  }
}

export default Transform;
